<template>
  <div class="ticketServiceSelect">
    <v-select
      v-model="value"
      :items="items"
      item-value="value"
      item-text="name"
      placeholder="サービスを選択してください。"
      @change="changeService"
      :disabled="!isServiceSelectable"
      class="UXselect"
      color="#6D8DFF"
      style="max-width: 500px;"
      hide-details
      outline
      solo
      no-data-text="データがありません。"
    ></v-select>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import eventType from '@/components/menus/ticket/enums/eventType'
import TicketListUtil from '../../../util/ticket_list_util'
import OptionType from '../../../enums/ticketListOptionType'
export default {
  name: 'ticket-service-select',
  props: {
    updateOption: Function,
    pageType: String,
    selectedService: Number,
    isServiceSelectable: Boolean
  },
  computed: {
    ...mapGetters([
      'currentTicketBrandId',
      'currentBrandId',
      'callMode'
    ])
  },
  mounted () {
    this.$eventBus.$on(eventType.FETCH_TICKET_BRAND, () => {
      if (this.currentTicketBrandId && this.callMode === 'KT') {
        this.getServiceList()
        this.value = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.SERVICE_ID, localStorage.getItem('TICKET_LIST_OPTION')) || null
      }
    })
  },
  destroyed () {
    this.$eventBus.$off(eventType.FETCH_TICKET_BRAND)
  },
  data () {
    return {
      items: [],
      value: null
    }
  },
  methods: {
    getServiceList () {
      if (this.callMode !== 'KT') return
      this.$http.get(`/gateway/ticket-channels?ticketBrandId=${this.currentTicketBrandId}`).then(result => {
        if (result.data.code === 0) {
          let resultList = result.data.data.map(m => {
            return { value: m.channelId, name: `${m.serviceName} (${m.serviceNumber})` }
          })
          this.items = [{ value: null, name: '全体' }, ...resultList]
        } else {
          this.$alertMsg(result.data.message)
        }
      }).catch(err => {
        this.$alertMsg(err)
      })
    },
    resetAll () {
      this.value = null
    },
    changeService () {
      this.updateOption('service', this.value)
    }
  }
}
</script>

<style lang="scss">
.ticketServiceSelect {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/ticket_service_select.vue